// removed by extract-text-webpack-plugin
module.exports = {"Paper":"_2ZseTjyYUWzu-U7FuLXtFQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Paper/index.css
// module id = 654
// module chunks = 0